<template>
  <div>
    <head-nav-bar title="结账" :fixed="true" />
    <div class="mt-header-nav confirm-box">
      <cell-box style="padding: 5px 0;" :column="2">
        <cell-item label="桌台：" :value="tableName" />
        <cell-item label="订单号：" :value="orderInfo.No" />
        <cell-item
          label="联系人："
          :value="orderInfo.Contact"
          style="gridColumn:span 2;"
        />
        <cell-item
          label="会员卡："
          v-if="orderInfo.MemberName"
          :value="orderInfo.MemberName"
          style="gridColumn:span 2;"
        />
        <cell-item label="电话：" :value="orderInfo.Phone" />
        <cell-item label="就餐人数：" :value="orderInfo.PersonCount" />
      </cell-box>
      <h3 class="selected-title">
        下单菜品
        <span class="show-all"
          >显示已付款菜品：<van-switch v-model="showPayDish"
        /></span>
      </h3>
      <div class="select-foods detail-select-table">
        <template v-for="item in orderFoodList">
          <van-card
            :key="item.DishId"
            v-if="
              (!item.HadPay && !showPayDish) || (showPayDish && item.HadPay)
            "
          >
            <template #price>
              <div style="color:#555">
                &yen;{{ item.UnitPrice }} x {{ item.Quantity }}
                <van-tag type="success" v-if="item.HadPay">已付款</van-tag>
              </div>
            </template>
            <template #title>
              <div class="food-title">
                <span>
                  {{ item.AccountItemName }}
                  <span
                    v-if="item.PracticeDesc || item.CookingMethodDesc"
                    class="method-txt"
                  >
                    「做法」{{ item.PracticeDesc }}{{ item.CookingMethodDesc }}
                  </span>
                </span>
                <span v-if="item.IsPack">
                  <van-tag color="#f60" @click="openPack(item)"
                    >套餐&nbsp;<van-icon
                      :name="
                        openKeys.includes(item.DishId) ||
                        openKeys.includes(item.Id)
                          ? 'arrow-up'
                          : 'arrow-down'
                      "
                  /></van-tag>
                </span>
              </div>
            </template>
            <template #num>
              <span style="color:#f00"> &yen;{{ item.TotalPrice }}</span>
            </template>
            <template v-if="item.IsPack" #footer>
              <ul
                class="pack-detail"
                :class="{
                  'pack-detail-open':
                    openKeys.includes(item.DishId) ||
                    openKeys.includes(item.Id),
                }"
              >
                <li v-for="pack in item.PackDetails" :key="pack.Id">
                  {{ pack.Name }} x {{ pack.Quantity }}
                </li>
              </ul>
            </template>
          </van-card>
        </template>
      </div>
    </div>
    <van-goods-action class="footer-action">
      <div slot="default" class="summary-info" style="width:65%;">
        <span>
          <van-icon name="balance-o" />总计：<em
            >&yen;{{ orderInfo.FinalAmount }}</em
          >
        </span>
        <span>
          <van-icon name="gold-coin-o" />待付：<em
            >&yen;{{ orderInfo.UnPayAmount }}</em
          >
        </span>
      </div>
      <van-goods-action-button
        type="danger"
        text="确认支付"
        :loading="loading"
        @click="onSubmit"
      />
    </van-goods-action>
  </div>
</template>

<script>
import "./rms.less";
import { CellBox, CellItem } from "@/components/cell";
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Card,
  Tag,
  Icon,
  Dialog,
  Toast,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Switch,
} from "vant";
import restaurantApi from "@/api/restaurant.js";
import { mapState } from "vuex";

export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    [Switch.name]: Switch,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderId: "",
      orderInfo: {},
      orderFoodList: [],
      tableName: "",
      tableId: "",
      loading: false,
      payOrderInfo: {},
      showPayDish: false,
      openKeys: [],
    };
  },
  created() {
    this.orderId = this.$route.query.OrderId;
    if (this.orderId) {
      this.getDetail();
    } else {
      Dialog.alert({
        message: "暂无订单！",
        theme: "round-button",
      }).then(() => {
        // on close
      });
    }
  },
  computed: {
    ...mapState({
      wechatUserInfo: state => state.user.wechatUserInfo,
    }),
  },
  methods: {
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    getDetail() {
      restaurantApi.getOrderDetail({ Id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.orderFoodList = this.orderInfo.DishTables[0].DishAccounts;
        this.tableName = this.orderInfo.DishTables[0].TableName;
        this.tableId = this.orderInfo.DishTables[0].TableId;
      });
    },
    onSubmit() {
      this.loading = true;
      const { orderInfo } = this;
      //获取本次预支付的商户订单号
      restaurantApi
        .getPayOrderId({ OrderId: orderInfo.Id })
        .then(res => {
          //发起H5预支付
          this.payOrderInfo = res.Data;
          this.wxPay(res.Data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    wxPay(data) {
      const { orderInfo, wechatUserInfo } = this;
      restaurantApi
        .wxPay({
          OpenId: wechatUserInfo.openid,
          NickName: wechatUserInfo.nickname,
          TotalAmount: data.TotalAmount,
          OrderId: orderInfo.Id,
          PayOrderId: data.PayOrderId,
          OrderNo: data.OrderNo,
        })
        .then(res => {
          //唤起微信支付
          this.handleGetDataSucc(res.Data);
          //轮询获取支付结果，发起H5预支付成功时调用
          this.pollingResult(data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pollingResult(data) {
      const { orderInfo } = this;
      restaurantApi
        .pollingGetPayResult(
          {
            restaurantOrderId: orderInfo.Id,
            PayOrderId: data.PayOrderId,
          },
          { handleError: false },
        )
        .then(() => {})
        .catch(() => {
          this.loading = false;
        });
    },
    handleGetDataSucc(data) {
      var that = this;
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            that.onBridgeReady(data),
            false,
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", that.onBridgeReady(data));
          document.attachEvent(
            "onWeixinJSBridgeReady",
            that.onBridgeReady(data),
          );
        }
      } else {
        console.log("准备调用微信支付");
        that.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      const that = this;
      console.log("调用微信支付WeixinJSBridge");
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.AppId, // 公众号名称，由商户传入
          timeStamp: data.TimeStamp, // 时间戳
          nonceStr: data.NonceStr, // 随机串
          package: data.Package, // 预支付id
          signType: data.SignType, // 微信签名方式
          paySign: data.PaySign, // 微信签名
        },
        function(res) {
          that.loading = false;
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            //支付成功，查看订单详情
            that.$router.push({
              name: "restaurantPayResult",
              query: {
                OrderId: that.orderId,
                TableId: that.tableId,
                PayOrderId: that.payOrderInfo && that.payOrderInfo.PayOrderId,
              },
            });
          } else {
            // Dialog.alert({
            //   message: "支付失败，请重试"
            // }).then(() => {});
          }
        },
      );
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 6.5rem);
  padding-bottom: 0;
}
.footer-action {
  padding: 5px 0;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
}
</style>
